import appClient from '../../common/services/AppClient';
import { endpoints } from '../../../config';
import type { ExecuteWebRequestConsoleRequest, WebRequestConsoleResult } from '../types';

export default class WebRequestConsoleService {
    async executeRequest(data: ExecuteWebRequestConsoleRequest) {
        const url = `${endpoints.manageUrl}WebRequestConsole/execute`;
        return appClient.post<WebRequestConsoleResult>(url, data);
    }
}
